import type { CSSProperties } from 'react';
import { renderCoachName } from '../../lib/coachName';
import styles from './CoachCardSmall.module.css';

type CoachCardSmallProps = {
  /** Coach name, e.g. "AIro" */
  name: string;
  /** Plain-English role, e.g. "Training Coach" */
  role: string;
  /** Short descriptor, e.g. "Session structure, zones, and weekly load." */
  desc: string;
  /** Accent color — CSS custom property or hex. Drives avatar bg. */
  color: string;
  /** Single-letter fallback for the avatar. Typically the name's first letter. */
  initial: string;
};

/**
 * Small coach card — used in the Step 7 Welcome outcome screen to
 * display the 5-coach roster.
 *
 * Renders a 34×34 square avatar with the coach's initial in
 * Instrument Serif (white on the coach's identity color), plus name +
 * role (micro-caps) + one-line descriptor.
 */
export function CoachCardSmall({ name, role, desc, color, initial }: CoachCardSmallProps) {
  const avatarStyle: CSSProperties & Record<string, string> = {
    '--coach-color': color,
  };

  return (
    <article className={styles.card}>
      <div className={styles.avatar} style={avatarStyle} aria-hidden>
        {initial}
      </div>
      <div className={styles.body}>
        <div className={styles.name}>{renderCoachName(name, color)}</div>
        <div className={styles.role}>{role}</div>
        <div className={styles.desc}>{desc}</div>
      </div>
    </article>
  );
}
